import type { SortingParams } from '@/common/types/sorting-params.types';
import type { GetWorkflowsDto } from '@/domains/workflows/api/workflow';
import { createQueryKeys } from '@lukemorales/query-key-factory';

import { fetchWorkflows } from '@/domains/workflows/api/workflow';

export const workflowKeys = createQueryKeys('workflows', {
  list: (query: GetWorkflowsDto, sorting: SortingParams) => ({
    queryKey: [{ query, sorting }],
    queryFn: () => fetchWorkflows(query, sorting),
  }),
});
